<script setup lang="ts">
import { useCurrentUser } from "vuefire"
// import { useUserStore } from "~~/layers/base/app/stores/user"
// import { useLangsStore } from "~~/layers/base/app/stores/langs"
// import { useDataStore } from "~~/layers/base/app/stores/data"
// import { setFirebaseFilters, getDateTimeFromSeconds, getSetPar } from "~~/layers/base/app/utils"
import { useDexStore } from "~/stores/dex"
// import { collection, doc, getDoc, query, where } from "firebase/firestore"

// const colorMode = useColorMode()
// const db = useFirestore()

// const color = computed(() => (colorMode.value === "dark" ? "#111827" : "white"))
// console.log(color)

useHead({
	meta: [
		{ charset: "utf-8" },
		{ name: "viewport", content: "width=device-width, initial-scale=1" },
		// { key: "theme-color", name: "theme-color", content: color },
	],
	// link: [{ rel: 'icon', href: '/favicon.ico' }],
	// htmlAttrs: {
	// 	lang: "en",
	// },
})

// const title = 'Nuxt UI Pro - Dashboard template'
// const description =
// 	"Nuxt UI Pro is a collection of premium Vue components built on top of Nuxt UI to create beautiful & responsive Nuxt applications in minutes."

// useSeoMeta({
// 	// title,
// 	description,
// 	// ogTitle: title,
// 	ogDescription: description,
// 	ogImage: "https://dashboard-template.nuxt.dev/social-card.png",
// 	twitterImage: "https://dashboard-template.nuxt.dev/social-card.png",
// 	twitterCard: "summary_large_image",
// })

const router = useRouter()
const route = useRoute()
const user = useCurrentUser()

onBeforeMount(async () => {
	const LangsStore = useLangsStore()

	await getSetPathPar(LangsStore.context, "lang_id")

	const UserStore = useUserStore()

	UserStore.user_route_role_map = [{ prefix: "/admin", role: "app", requestAccess: "/admin/requestaccess" }]

	if (user && user.value) {
		console.log("init user 0", "is auth", user.value)

		initUser(user.value)
	} else {
		// console.log("init annonymous", "is auth", user.value)
		const DataStore = useDataStore()
		const DexStore = useDexStore()
		DataStore.initLangsData(DataStore, "set")
		// if (user_role_apps["planner"]) {
		DataStore.initLangsData(DexStore, "set")
	}
})

watch(user, async (currentUser, previousUser) => {
	// redirect to login if they logout and the current route is only for authenticated users
	// console.log("watch", "1", user.value)
	const LangsStore = useLangsStore()

	if (
		!currentUser &&
		previousUser
		// &&
		// (Array.isArray(route.meta.middleware)
		// 	? route.meta.middleware.includes("client-auth")
		// 	: route.meta.middleware === "client-auth")
	) {
		console.log("watch user", "not auth")
		// const UserStore = useUserStore()
		// UserStore.destroyLocalData()
		return router.push({ path: "/" + LangsStore.context.lang_id + "/login" })
	} else if (currentUser) {
		console.log("watch user", "is auth", currentUser)

		initUser(currentUser)

		// const DexStore = useDexStore()

		// DexStore.init(true)

		// console.log(JSON.stringify(AccountingStore.presets))

		// AccountingStore.initAll()
		//
		// console.log(user)

		// init user data
		// MainStore.initData(currentUser)
		// redirect the user if they are logged in but were rejected because the user wasn't ready yet
		if (typeof route.query.redirect === "string") {
			return router.push(route.query.redirect)
		}
	}
})

async function initUser(user: any) {
	const UserStore = useUserStore()
	const DataStore = useDataStore()
	const DexStore = useDexStore()

	await UserStore.initUserRoles(user)
	UserStore.listenForRoleChanges(user)

	// const user_role_apps = (await getDoc(doc(db, "users_roles", user.uid))).data()?.apps_access

	// for (const app_name of ["planner", "dextools", "accounting"]) {
	// 	console.log("initUser APPS", app_name, user_role_apps[app_name])

	// 	switch (app_name) {
	// 		case "planner":
	// 			{

	DataStore.initAppData(DataStore, "set", UserStore.user_full)

	// if (user_role_apps["planner"]) {
	DataStore.initAppData(DexStore, "set", UserStore.user_full)
	// } else {
	// 	DataStore.initAppData(DexStore, "destroy", UserStore.user_full)
	// }
	// 			}
	// 			break
	// 	}
	// }

	// console.log(user_role_apps)

	// user_full.value = { auth: user, roles: user_roles }
}
</script>

<template>
	<UApp :toaster="{ position: 'bottom-right' }">
		<NuxtLoadingIndicator />

		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
	</UApp>
</template>
